<template>
  <b-modal :title="modal?.title"
           :modelValue="modal !== null"
           footer-class="d-flex justify-content-between"
           @update:modelValue="$event === false && (modal = null)">
    <template #default>
      <div class="row" v-if="modal?.direction === Direction.PAY_IN">
        <div class="col-sm-12">
          <div class="form-check">
            <input class="form-check-input" v-model="form.reason" :value="DisputeReason.NO_PAYMENT" type="radio" name="reason" id="no_payment">
            <label class="form-check-label" for="no_payment">
              {{ helper.trans(`dispute_reason.${DisputeReason.NO_PAYMENT}`) }}
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" v-model="form.reason" :value="DisputeReason.HAS_PAYMENT" type="radio" name="reason" id="HAS_PAYMENT">
            <label class="form-check-label" for="HAS_PAYMENT">
              {{ helper.trans(`dispute_reason.${DisputeReason.HAS_PAYMENT}`) }}
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" v-model="form.reason" :value="DisputeReason.INVALID_SUM" type="radio" name="reason" id="invalid_sum">
            <label class="form-check-label" for="invalid_sum">
              {{ helper.trans(`dispute_reason.${DisputeReason.INVALID_SUM}`) }}
            </label>
          </div>
        </div>
      </div>
      <div class="row" v-if="modal?.direction === Direction.PAY_OUT">
        <div class="col-sm-12">
          <div class="form-check">
            <input class="form-check-input" v-model="form.reason" :value="DisputeReason.NO_PAYMENT" type="radio" name="reason" id="NO_PAYMENT">
            <label class="form-check-label" for="NO_PAYMENT">
              {{ helper.trans(`dispute_reason.${DisputeReason.NO_PAYMENT}_out`) }}
            </label>
          </div>
          <div class="form-check" v-if="modal?.deal.status !== DealStatus.DISPUTE">
            <input class="form-check-input" v-model="form.reason" :value="DisputeReason.WAITING_CONFIRMATION" type="radio" name="reason" id="WAITING_CONFIRMATION">
            <label class="form-check-label" for="WAITING_CONFIRMATION">
              {{ helper.trans(`dispute_reason.${DisputeReason.WAITING_CONFIRMATION}`) }}
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" v-model="form.reason" :value="DisputeReason.INVALID_REQUISITES" type="radio" name="reason" id="INVALID_REQUISITES">
            <label class="form-check-label" for="INVALID_REQUISITES">
              {{ helper.trans(`dispute_reason.${DisputeReason.INVALID_REQUISITES}`) }}
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" v-model="form.reason" :value="DisputeReason.PAYOUT_BLACKLIST" type="radio" name="reason" id="PAYOUT_BLACKLIST">
            <label class="form-check-label" for="PAYOUT_BLACKLIST">
              {{ helper.trans(`dispute_reason.${DisputeReason.PAYOUT_BLACKLIST}`) }}
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" v-model="form.reason" :value="DisputeReason.UNABLE_TO_PAY_OUT_ON_REQ" type="radio" name="reason" id="UNABLE_TO_PAY_OUT_ON_REQ">
            <label class="form-check-label" for="UNABLE_TO_PAY_OUT_ON_REQ">
              {{ helper.trans(`dispute_reason.${DisputeReason.UNABLE_TO_PAY_OUT_ON_REQ}`) }}
            </label>
          </div>
          <div class="form-check" v-if="modal?.deal.status !== DealStatus.DISPUTE">
            <input class="form-check-input" v-model="form.reason" :value="DisputeReason.PART_PAYOUT" type="radio" name="reason" id="PART_PAYOUT">
            <label class="form-check-label" for="PART_PAYOUT">
              {{ helper.trans(`dispute_reason.${DisputeReason.PART_PAYOUT}`) }}
            </label>
          </div>
        </div>
      </div>

       <div v-if="[DisputeReason.INVALID_SUM, DisputeReason.PART_PAYOUT].includes(form.reason)" class="row">
         <label for="amount" class="col-sm-4 col-form-label text-capitalize-first pe-2">{{ helper.trans("labels.sum") }}</label>
         <div class="col-sm-4">
           <FormInputWrapper v-slot="parentProps" :errors="getErrors(`disputeReasonData.amount`)" >
             <input v-model="form.amount"
                    :class="parentProps.class"
                    v-maska
                    data-maska="9.##"
                    data-maska-tokens="9:[0-9]:multiple"
                    type="text" class="form-control " id="amount">
           </FormInputWrapper>


         </div>
       </div>
      <div v-if="DisputeReason.PART_PAYOUT === form.reason || modal?.direction === Direction.PAY_IN" class="mt-3">
        <div class="row mb-3">
          <div class="col-sm-12">
            <div v-if="modal?.direction === Direction.PAY_IN" style="cursor: pointer; border:1px dashed" v-bind="payInDropzone.getRootProps()" class="payout-dropzone rounded border-secondary p-3 pt-4 pb-4 d-flex justify-content-center align-items-center">
              <input v-bind="payInDropzone.getInputProps()" />
              <p class="p-0 m-0">{{ helper.trans('labels.payout_upload_files')}}</p>
            </div>
            <div v-else style="cursor: pointer; border:1px dashed" v-bind="dropzone.getRootProps()" class="payout-dropzone rounded border-secondary p-3 pt-4 pb-4 d-flex justify-content-center align-items-center">
              <input v-bind="dropzone.getInputProps()" />
              <p class="p-0 m-0">{{ helper.trans('labels.payout_upload_files')}}</p>
            </div>
          </div>
        </div>
        <div v-for="fileAttachment in fileAttachments" class="row mb-2 ms-2" :key="fileAttachment.id">
          <div class="col-sm-12">
            <i class="fa fa-paperclip"></i> <span class="me-2">{{ fileAttachment.file.name}}</span>
            <div v-if="fileAttachment.error === null && fileAttachment.attachment === null" class="spinner-border" role="status" style="zoom: 0.5">
              <span class="visually-hidden"></span>
            </div>
            <a v-else href="#" @click.prevent="removeFile(fileAttachment)">
              <i class="fa fa-times"></i>
            </a>
            <div>
              <small class="text-danger" v-if="fileAttachment.error !== null">{{fileAttachment.error}}</small>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      <button type="button" @click="modal = null" class="btn btn-outline-dark btn-sm text-capitalize-first">
        {{ modal?.cancelTitle ?? helper.trans('button.cancel')  }}
      </button>
      <LoaderWrapper ref="loader" :zoom="0.5">
        <button type="button" @click="onOkClick()" class="btn btn-outline-danger btn-sm text-capitalize-first">
          {{ modal?.okTitle ?? helper.trans('button.ok') }}
        </button>
      </LoaderWrapper>

    </template>
  </b-modal>
</template>

<script lang="ts">

import {computed, defineComponent, ref} from 'vue'
import {reactive, toRefs} from "@vue/reactivity";
import {BModal} from "bootstrap-vue-3";
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {helper} from "@/service/CommonHelper";
import {DisputeReason} from "@/models/enum/DisputeReason";
import {Direction} from "@/models/enum/Direction";
import AttachmentDTO from "@/models/AttachmentDTO";
import APIClient from "@/service/APIClient";
import {useNotification} from "@kyvg/vue3-notification";
import {useDropzone} from "vue3-dropzone";
import ValidationErrorDTO from "@/models/ValidationErrorDTO";
import FormInputWrapper from "@/components/FormInputWrapper.vue";
import {useStore} from "vuex";
import TraderDealDTO from "@/models/TraderDealDTO";
import {DealStatus} from "@/models/enum/DealStatus";

interface AttachmentFileDTO {
  id: number;
  attachment: AttachmentDTO|null,
  file: File,
  error: string|null
}

export interface DisputeConfirmModalProps {
  direction: Direction,
  deal: TraderDealDTO,
  title: string;
  okTitle: string|null,
  cancelTitle: string|null,
  onOkClick(): void
}

const api = new APIClient();
const notification = useNotification()
let id = 0;
export default defineComponent({
  components: {
    FormInputWrapper,
    BModal,
    LoaderWrapper
  },
  setup() {
    const store = useStore();
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)

    const state = reactive({
      modal: null as DisputeConfirmModalProps|null,
      form: {
        reason: DisputeReason.NO_PAYMENT as DisputeReason,
        amount: '' as string
      },
      errors: {} as ValidationErrorDTO[]|any,
      fileAttachments: [] as AttachmentFileDTO[],
    });

    const setErrors = (data: ValidationErrorDTO[]) => {
      state.errors = {};
      for (const error of data) {
        if (!state.errors.hasOwnProperty(error.field)) {
          state.errors[error.field] = [];
        }
        state.errors[error.field].push(error)
      }
    }

    const onDrop = async (acceptFiles: any, rejectReasons: any) => {
      for (const file of acceptFiles) {
        state.fileAttachments.push({
          id: id++,
          attachment: null,
          file,
          error: null
        } as AttachmentFileDTO)
      }

      for (const fileAttachment of state.fileAttachments) {
        try {
          fileAttachment.attachment = await api.attachmentsUpload(fileAttachment.file)
        } catch (e) {
          console.log(e);
          if (helper.isValidationErrors(e)) {
            for (const item of helper.getValidationErrors(e)) {
              notification.notify({type: 'error', title: helper.trans(`server_errors.${item.code}`, {}, item.message)});
            }
          } else {
            notification.notify({type: 'error', title: helper.trans(`server_errors.c8c7315c-6186-4719-8b71-5659e16bdcb7`)});
          }
          fileAttachment.error = helper.trans(`server_errors.c8c7315c-6186-4719-8b71-5659e16bdcb7`)
        }

      }
    }
    const dropzone = useDropzone({ onDrop });
    const payInDropzone = useDropzone({ onDrop, maxFiles: 1, multiple: false });

    const getForm = () => {
      let data = {
        disputeReason: state.form.reason,
        disputeReasonData: {},
        attachments: state.fileAttachments.filter((file) => file.attachment !== null).map((file) => file.attachment!.id)
      }


      if ([DisputeReason.INVALID_SUM, DisputeReason.PART_PAYOUT].includes(state.form.reason)) {
          data.disputeReasonData = {
            amount: parseFloat(state.form.amount)
          }
      }

      return data;
    }

    const getErrors = (path: string) => {
      if (!state.errors.hasOwnProperty(path)) {
        return [];
      }

      return state.errors[path]
    }

    const removeFile = (fileAttachment: AttachmentFileDTO) => {
      state.fileAttachments = state.fileAttachments.filter((file) => file.id !== fileAttachment.id)
    }

    const show = (props: DisputeConfirmModalProps) => {
      state.errors = {};
      state.modal = props
      state.form.reason = DisputeReason.NO_PAYMENT
      state.fileAttachments = [];
      state.form.amount = ''
    }

    const onOkClick = async () => {
      if (!state.modal) {
        return;
      }

      loader.value?.show()
      try {
        await state.modal.onOkClick();
      } finally {
        loader.value?.hide()
      }

      state.modal = null;
    }

    return {
      ...toRefs(state),
      dropzone,
      payInDropzone,
      onOkClick,
      show,
      loader,
      helper,
      DisputeReason,
      getForm,
      Direction,
      removeFile,
      setErrors,
      getErrors,
      DealStatus,
      isOperator: computed<boolean>(() => store.getters.isOperator),
      isAdmin: computed<boolean>(() => store.getters.isAdmin)
    }
  }
})
</script>
